export default __webpack_public_path__ + "cbccead0818f9c7a49e64ca7bcefb399.png";